import axios from 'axios';
import qs from 'query-string';
import { getClientID } from '../config/configurations';
import { edulaiInstance } from './instances/edulaiInstance';

let clientSecret = '' || process.env.REACT_APP_CLIENT_SECRET;

export function setClientSecret(secret) {
  if (secret) clientSecret = secret;
}

export const authenticate = async (username, password) => {
  const clientId = getClientID();
  const config = {
    auth: {
      username: clientId,
      password: clientSecret || process.env.REACT_APP_CLIENT_SECRET
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  };

  const credentials = {
    grant_type: 'password',
    username,
    password
  };
  return edulaiInstance.post('/oauth2/token', qs.stringify(credentials), config);
};

export const refresh = async (token) => {
  const clientId = getClientID();
  const config = {
    auth: {
      username: clientId,
      password: clientSecret
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  };

  const credentials = {
    grant_type: 'refresh_token',
    refresh_token: token
  };
  return edulaiInstance.post('/oauth2/token', qs.stringify(credentials), config);
};

const configurationInstance = axios.create({
  timeout: 30000,
  baseURL: window.location.origin
});

export function fetchConfiguration() {
  return configurationInstance.get('/api/v1/backendInfo');
}
